import React from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
export const PAGE_SIZE = 25;

export function getHeaders() {
  const token = localStorage.getItem('auth_token');
  return token ? { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json' };
}

export function Spinner({ text }) {
  return (
    <div className="flex items-center justify-center py-12">
      <div className="animate-spin w-5 h-5 border-2 border-gray-500 border-t-white rounded-full mr-3" />
      <p className="text-sm text-gray-400">{text}</p>
    </div>
  );
}

export function Empty({ text }) {
  return <div className="text-center py-8"><p className="text-sm text-gray-500">{text}</p></div>;
}

export function Pagination({ page, totalPages, onPageChange, label }) {
  if (totalPages <= 1) return null;
  return (
    <div className="flex items-center justify-between pt-3 border-t border-gray-700">
      <p className="text-xs text-gray-500">{label}</p>
      <div className="flex items-center gap-2">
        <button data-testid="pagination-back" onClick={() => onPageChange(page - 1)} disabled={page <= 1}
          className="px-3 py-1 text-xs bg-gray-700 text-gray-300 rounded-lg hover:bg-gray-600 disabled:opacity-30 disabled:cursor-not-allowed transition">Back</button>
        <span className="text-xs text-gray-400">{page} / {totalPages}</span>
        <button data-testid="pagination-next" onClick={() => onPageChange(page + 1)} disabled={page >= totalPages}
          className="px-3 py-1 text-xs bg-gray-700 text-gray-300 rounded-lg hover:bg-gray-600 disabled:opacity-30 disabled:cursor-not-allowed transition">Next</button>
      </div>
    </div>
  );
}

export const VALUE_BUCKETS = [
  { key: 'under100k', label: '< $100K', min: 0, max: 100000 },
  { key: '100k-500k', label: '$100K - $500K', min: 100000, max: 500000 },
  { key: '500k-1m', label: '$500K - $1M', min: 500000, max: 1000000 },
  { key: '1m-5m', label: '$1M - $5M', min: 1000000, max: 5000000 },
  { key: 'over5m', label: '> $5M', min: 5000000, max: Infinity },
];

export function getBucket(value) {
  for (const b of VALUE_BUCKETS) {
    if (value >= b.min && value < b.max) return b.key;
  }
  return 'over5m';
}

export const AGE_FILTERS = [
  { key: 'all', label: 'All' },
  { key: 'new', label: 'New (< 30d)' },
  { key: 'recent', label: 'Recent (30d - 6mo)' },
  { key: 'established', label: 'Established (6mo - 1yr)' },
  { key: 'veteran', label: 'Veteran (1yr+)' },
];

export function getAgeCategory(isoDate) {
  if (!isoDate) return 'all';
  const days = Math.floor((Date.now() - new Date(isoDate).getTime()) / 86400000);
  if (days < 30) return 'new';
  if (days < 180) return 'recent';
  if (days < 365) return 'established';
  return 'veteran';
}

export { API_URL };
